import { CaseDetails } from '../components/CaseDetails';
import { useSettingsContext } from '../context/SettingsContext';

export const CaseDetailsRoute = () => {
  const {
    isLoadingCaseIssues,
    caseIssues,
    caseParties,
    caseContext,
    caseTimePeriod,
    handleIssuesChange,
    handlePartiesChange,
    handleContextChange,
    handleTimePeriodChange,
    setConfirmationModalOpen,
    detailsChanged,
    isReprocessing,
  } = useSettingsContext();

  return (
    <CaseDetails
      isLoading={isLoadingCaseIssues}
      caseIssues={caseIssues}
      caseParties={caseParties}
      caseContext={caseContext}
      caseTimePeriod={caseTimePeriod}
      handleIssuesChange={handleIssuesChange}
      handlePartiesChange={handlePartiesChange}
      handleContextChange={handleContextChange}
      handleTimePeriodChange={handleTimePeriodChange}
      setConfirmationModalOpen={setConfirmationModalOpen}
      detailsChanged={detailsChanged}
      isReprocessing={isReprocessing}
    />
  );
};
